import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Popconfirm } from 'antd';
import { dayFormatType, formatDay } from 'common/helpers/day';
import { debounce } from 'lodash';
import SpinLoading from '../spin-loading';

const NoteList = props => {
  const { notes, hasMore, loading, onEdit, onDelete, onLoadMore } = props;
  const { t } = useTranslation();

  const handleLoadMore = useCallback(
    debounce(() => {
      onLoadMore?.();
    }, 300),
    [onLoadMore],
  );

  const handleEdit = (id, note) => {
    onEdit?.(id, note);
  };

  const handleDelete = id => {
    onDelete?.(id);
  };

  return (
    <div className="note-list__wrapper">
      <ul className="note-list">
        {notes?.map((note, index) => (
          <li key={note.id} className="note-list__list-item">
            <div className="note-list__bullet-item">
              <div
                className="note-list__bullet-item--prefix"
                style={{ visibility: index > 0 ? 'visible' : 'hidden' }}
              />
              <div className="note-list__bullet-point" />
              <div
                className="note-list__bullet-item--suffix"
                style={{ visibility: index < notes.length - 1 ? 'visible' : 'hidden' }}
              />
            </div>
            <div
              className={`note-list__item-wrapper ${
                index >= notes.length - 1 ? 'note-list__item-wrapper--no-border' : ''
              }`}
            >
              <div className="note-list__item">
                <div className="note-list__item-content">
                  <p className="note-list__item-text">{note.note}</p>
                  <div className="note-list__update-info">
                    <span className="note-list__item-time">
                      {formatDay(dayFormatType.FULLDATEANDTIME, note.updatedAt)}
                    </span>
                    <div className="note-list__divider" />
                    <span className="note-list__item-author">{`${t(
                      'cms:cms.students.detail.panel.notes.updated_by',
                    )} ${note.updatedByName}`}</span>
                  </div>
                </div>
                <div className="note-list__item-actions">
                  <button
                    className="note-list__button note-list__edit-button"
                    onClick={() => handleEdit(note.id, note.note)}
                  >
                    {t('cms:cms.students.detail.panel.notes.edit')}
                  </button>
                  <div className="note-list__divider" />
                  <Popconfirm
                    title={t('cms:cms.students.detail.panel.notes.confirm_delete')}
                    okText={t('cms:cms.students.detail.panel.notes.delete')}
                    okType="danger"
                    placement="topRight"
                    onConfirm={() => {
                      handleDelete(note.id);
                    }}
                  >
                    <button className="note-list__button note-list__delete-button">
                      {t('cms:cms.students.detail.panel.notes.delete')}
                    </button>
                  </Popconfirm>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {loading && <SpinLoading className="note-list__loading" />}
      {hasMore && !loading && (
        <button className="note-list__load-more" onClick={handleLoadMore}>
          {t('cms:cms.students.detail.panel.notes.load_more')}
        </button>
      )}
    </div>
  );
};
export default NoteList;
